import { Icon } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const CardIslePreviewWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const CardIsleButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 4px;
`;

const CardIslePreviewColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const PreviewItemIconButton = styled.button`
  align-items: center;
  background-color: var(--color-bg-stronger);
  border: none;
  border-radius: var(--size-border-radius-circle);
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;

  ${Icon.S.Icon} {
    fill: var(--color-fg-inverse-default);
    pointer-events: none;
  }

  &:focus {
    outline: none;
  }
`;

export {
  CardIsleButtonsWrapper,
  CardIslePreviewColumn,
  CardIslePreviewWrapper,
  PreviewItemIconButton
};
